export const PAGES = {
  HOME: "/",
  AML_CHECK: "/aml-check",
  POST_PAYMENT: "/post-payment",
  AML_CHECK_DETAILS: "/aml-check-details",
  AML_HISTORY: "/aml-history",
  ERROR_PAGE: "/error",
};
